// Функция для форматирования значений настроек без лишних нулей
export const formatSettingValue = (value) => {
  if (value === null || value === undefined || value === '') return '';
  
  // Преобразуем в число
  const num = parseFloat(value);
  
  // Если не число, возвращаем как есть
  if (isNaN(num)) return value;
  
  // Убираем лишние нули после запятой
  // Используем toPrecision для удаления trailing zeros
  const formatted = parseFloat(num.toFixed(10));
  
  return formatted.toString();
};

// Функция для парсинга значения из поля ввода
export const parseSettingValue = (value) => {
  if (value === '' || value === null || value === undefined) return '';
  
  // Заменяем запятую на точку для корректного парсинга
  const normalizedValue = String(value).replace(',', '.');
  
  const num = parseFloat(normalizedValue);
  if (isNaN(num)) return '';
  
  return num;
};